import { useUnit } from 'effector-react';
import { ReactNode } from 'react';
import { gameModel } from 'entities/game';
import { NumberFormatter } from 'shared/ui';
import cls from './sidebar-settings-item.module.scss';

type SidebarSettingsItemProps = {
	label: ReactNode;
	value: number;
};

export const SidebarSettingsItem = ({ label, value }: SidebarSettingsItemProps) => {
	const currency = useUnit(gameModel.$currency);

	return (
		<li className={cls.sidebarSettingsItem}>
			<span className={cls.sidebarSettingsItemLabel}>{label}:</span>{' '}
			<NumberFormatter
				fixedDecimalScale
				value={value}
				suffix={` ${currency}`}
				decimalScale={2}
				thousandSeparator=' '
			/>
		</li>
	);
};
